var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useMemo, useReducer, useState } from "react";
import { useAppDispatch } from "../hooks/hooks";
import { ordersConstants } from "../store/actions/types";
import Modal from "./Modal";
import closeIcon from "../assets/icons/close.svg";
import toast from "react-hot-toast";
import { createOrder, patchOrder } from "../utils/ordersApi";
import { makeSessionRequest } from "../utils/makeSessionRequest";
export default function NewOrderForm({ show, closeNewOrderForm, currentOrder, }) {
    const [formErrors, setFormErrors] = useState();
    const [customerPhoneNumber, setCustomerPhoneNumber] = useState("");
    const [customerName, setCustomerName] = useState("");
    const [customerEmail, setCustomerEmail] = useState("");
    const [customerLocation, setCustomerLocation] = useState("");
    const [leadId, setLeadId] = useState("");
    const [orderStatus, setOrderStatus] = useState(0);
    const [companyName, setCompanyName] = useState("");
    const [orderDescription, setOrderDescription] = useState(undefined);
    const initialState = useMemo(() => ({
        cart_items: [],
        customer: {
            name: customerName,
            phone_number: customerPhoneNumber,
            email: customerEmail,
            location: customerLocation,
        },
        custom_data: {
            delivery_time: "",
            advance_payment: 0,
            company_name: "",
        },
        documents: {
            xls: "",
        },
        lead_id: leadId,
        _id: "",
        viewer: process.env.REACT_APP_VIEWER_ID,
        status: {
            status: 0,
            description: orderDescription,
        },
    }), [
        customerEmail,
        customerLocation,
        customerName,
        customerPhoneNumber,
        leadId,
        orderDescription,
    ]);
    const [state, dispatch] = useReducer(reducer, initialState, () => initialState);
    useEffect(() => {
        var _a, _b;
        if (currentOrder) {
            setCustomerName(currentOrder.customer.name);
            setCustomerEmail(currentOrder.customer.email);
            setCustomerPhoneNumber(currentOrder.customer.phone_number);
            setCustomerLocation(currentOrder.customer.location);
            setOrderStatus(currentOrder.status.status);
            setOrderDescription(currentOrder.status.description);
            setLeadId(currentOrder.lead_id);
            ((_a = currentOrder.custom_data) === null || _a === void 0 ? void 0 : _a.company_name) &&
                setCompanyName((_b = currentOrder.custom_data) === null || _b === void 0 ? void 0 : _b.company_name);
        }
    }, [currentOrder]);
    useEffect(() => {
        if (orderStatus !== 2) {
            setOrderDescription("");
        }
    }, [orderStatus]);
    function reducer(state, action) {
        var _a, _b, _c;
        switch (action.type) {
            case "SET_VALUES":
                return Object.assign(Object.assign({}, state), { [(_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.id]: (_b = action === null || action === void 0 ? void 0 : action.payload) === null || _b === void 0 ? void 0 : _b.value });
            case "RESET_FORM":
                return initialState;
            case "SET_ORDER":
                return (_c = action === null || action === void 0 ? void 0 : action.payload) === null || _c === void 0 ? void 0 : _c.value;
            default:
                return state;
        }
    }
    const dispatchRdx = useAppDispatch();
    // const user = useAppSelector((state) => state.user);
    useEffect(() => {
        dispatch({ type: "RESET_FORM" });
        if (currentOrder) {
            dispatch({
                type: "SET_ORDER",
                payload: {
                    value: Object.assign(Object.assign({}, currentOrder), { 
                        //select filed doesn't reset
                        status: currentOrder.status || 0 }),
                },
            });
        }
    }, [currentOrder, initialState, show]);
    const onSubmit = (e) => __awaiter(this, void 0, void 0, function* () {
        e.preventDefault();
        if (!customerName) {
            toast.error("Please enter your name");
            return;
        }
        if (!customerPhoneNumber.match(/([+]?\d[.91][.-\s]?)?(\d{3}?){2}\d{4}/)) {
            toast.error("Please enter a valid phone number");
            return;
        }
        // if (!leadId) {
        //   toast.error("Please enter your Salesforce id");
        //   return;
        // }
        if (!companyName) {
            toast.error("Please enter Company Name");
            return;
        }
        if (!customerEmail.match(/^([a-zA-Z0-9_\-+.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/)) {
            toast.error("Please enter a valid email address");
            return;
        }
        if (!customerLocation) {
            toast.error("Please enter customer location");
            return;
        }
        const order = Object.assign(Object.assign({}, state), { customer: {
                name: customerName,
                phone_number: customerPhoneNumber,
                email: customerEmail,
                location: customerLocation,
            }, lead_id: leadId, custom_data: {
                company_name: companyName,
            }, _id: state._id ? state._id : "", viewer: process.env.REACT_APP_VIEWER_ID, status: {
                status: orderStatus,
                description: orderDescription,
            } });
        makeSessionRequest(state._id ? "saved_quotation" : "created_quotation", state._id && {
            orderId: order._id,
        });
        try {
            if (order._id) {
                const data = yield patchOrder(order);
                dispatchRdx({
                    type: ordersConstants.UPDATE_ORDER,
                    payload: Object.assign(Object.assign({}, order), { created_at: data.created_at, updated_at: data.updated_at }),
                });
                toast.success("Order updated successfully");
            }
            else {
                delete order._id;
                const data = yield createOrder(order);
                dispatchRdx({
                    type: ordersConstants.ADD_ORDER,
                    payload: Object.assign(Object.assign({}, order), { _id: data._id, createdAt: data.createdAt, updatedAt: data.updatedAt }),
                });
                toast.success("Order created successfully");
            }
            dispatch({ type: "RESET_FORM" });
            setFormErrors(undefined);
            setCustomerName("");
            setCustomerEmail("");
            setCustomerPhoneNumber("");
            setCustomerLocation("");
            setLeadId("");
            closeNewOrderForm();
            window.location.reload();
        }
        catch (error) {
            console.error(error);
            toast.error("Failed to create order");
        }
    });
    return (_jsx("div", { children: _jsx(Modal, Object.assign({ show: show, onClose: () => null }, { children: _jsxs("form", Object.assign({ onSubmit: onSubmit, className: "p-2 w-96 flex flex-col overflow-y-scroll", style: { maxHeight: "85vh" } }, { children: [_jsxs("div", Object.assign({ className: "flex mb-4" }, { children: [_jsx("h1", Object.assign({ className: "font-bold text-lg " }, { children: state._id ? "Edit Customer Details" : "New Customer Form" })), _jsx("img", { className: "ml-auto cursor-pointer", onClick: () => {
                                    setFormErrors(undefined);
                                    setCustomerName("");
                                    setCustomerEmail("");
                                    setCustomerPhoneNumber("");
                                    setCustomerLocation("");
                                    setLeadId("");
                                    setOrderStatus(0);
                                    setOrderDescription(undefined);
                                    dispatch({ type: "RESET_FORM" });
                                    dispatchRdx({
                                        type: ordersConstants.SET_CURRENT_ORDER,
                                        payload: null,
                                    });
                                    makeSessionRequest("quotation_closed");
                                    closeNewOrderForm();
                                }, src: closeIcon, alt: "" })] })), _jsx("p", Object.assign({ className: "mb-2" }, { children: "Company Name: " })), _jsx("input", { className: " px-4 py-2 w-full focus:outline-none border mb-4", type: "text", value: companyName, onChange: (e) => setCompanyName(e.target.value) }), _jsx("p", Object.assign({ className: "mb-2" }, { children: "Point of Contact : " })), _jsx("input", { className: " px-4 py-2 w-full focus:outline-none border mb-4", type: "text", value: customerName, onChange: (e) => setCustomerName(e.target.value) }), _jsx("p", Object.assign({ className: "mb-2" }, { children: "Point of Contact's Number: " })), _jsx("input", { className: "px-4 py-2 w-full focus:outline-none border mb-4", inputMode: "tel", value: customerPhoneNumber, onChange: (e) => setCustomerPhoneNumber(e.target.value) }), _jsx("p", Object.assign({ className: "mb-2" }, { children: "Point of Contact's Email: " })), _jsx("input", { className: "px-4 py-2 w-full focus:outline-none border mb-4", type: "text", value: customerEmail, onChange: (e) => setCustomerEmail(e.target.value) }), _jsx("p", Object.assign({ className: "mb-2" }, { children: "Company Location: " })), _jsx("input", { className: "px-4 py-2 w-full focus:outline-none border mb-4", type: "text", value: customerLocation, onChange: (e) => setCustomerLocation(e.target.value) }), _jsx("p", Object.assign({ className: "mb-2" }, { children: "SalesForce Id: " })), _jsx("input", { className: "px-4 py-2 w-full focus:outline-none border mb-4", type: "text", name: "salesForceId", value: leadId, onChange: (e) => setLeadId(e.target.value) }), _jsx("p", Object.assign({ className: "mb-2" }, { children: "Status: " })), _jsxs("select", Object.assign({ onChange: (e) => setOrderStatus(parseInt(e.target.value)), value: orderStatus, className: "px-4 py-2 w-full focus:outline-none border mb-4", name: "status", id: "" }, { children: [_jsx("option", Object.assign({ value: 0 }, { children: "New" })), _jsx("option", Object.assign({ value: 1 }, { children: "Received" })), _jsx("option", Object.assign({ value: 2 }, { children: "Lost" }))] })), orderStatus === 2 && (_jsxs(_Fragment, { children: [_jsx("p", Object.assign({ className: "mb-2" }, { children: "Reason: " })), _jsx("input", { className: "px-4 py-2 w-full focus:outline-none border mb-4", type: "text", name: "reason", value: orderDescription, onChange: (e) => setOrderDescription(e.target.value) })] })), formErrors === null || formErrors === void 0 ? void 0 : formErrors.errors.map((err) => (_jsx("p", Object.assign({ className: "text-red-500 text-sm" }, { children: err }), err))), _jsx("button", Object.assign({ className: " tracking-widest text-xs my-4  py-3 px-8 hover:bg-black bg-customBlack-light text-white rounded-full font-bold transform transition-colors" }, { children: state._id ? "Save" : "Add Customer" }))] })) })) }));
}
